/**
 * Created by rak on 3/24/2016.
 */
'use strict';

angular.module('betosyswebapp')
  .controller('DriverDashboardCtrl', function ($rootScope, $scope, AuthenticationService, base64, localStorageService, $translate, commonTrackService, dashboardService, customerService) {
    $scope.pageHeader = 'Driver Dashboard';

    var loginID = AuthenticationService.GetLoginID();

    //dash board
    $scope.username = loginID.username;
    $scope.dashBoardName = 'dashBoard.DriverDashboard.' + $scope.username;
    var model = localStorageService.get($scope.dashBoardName);

    if (!model) {
      model = customerService.getDriverDashboardConfig(commonTrackService.getViewPortName());
    }

    $scope.dashBoardModel = model;
    $scope.collapsible = true;
    $scope.maximizable = true;

    $scope.widgetFilter = function (widget, type) {
      if (!isExculdedParentWidget(type) && (widget.isSingleInstance === undefined || notExist(type))) {
        return type;
      }
    };

    function notExist(type) {
      return !dashboardService.getDashboardWidget($scope.dashBoardModel, type);
    }

    var isExculdedParentWidgetArr = ['vehicleListWidget', 'tachoHistoryWidget', 'FMSVehicleWidget', 'tachoDownloadStatusWidget'];

    function isExculdedParentWidget(type) {
      for (var j = 0; j < isExculdedParentWidgetArr.length; j++) {
        if (type === isExculdedParentWidgetArr[j]) {
          return true;
        }
      }
      return false;
    }
    var adfDashboardChangedEvnt = $scope.$on('adfDashboardChanged', function (event, name, model) {
      localStorageService.set(name, model);
    });

    var rowSelectedEvnt = $scope.$on('rowSelected', function (event, data) {
      if (data.selectedRow) {
        commonTrackService._loopWidgetsInDashboard($scope.dashBoardModel, commonTrackService.getVehicleBasedWidgetNameArray(), data.selectedRow.devicedesc);
      } else {
        commonTrackService._loopWidgetsInDashboard($scope.dashBoardModel, commonTrackService.getVehicleBasedWidgetNameArray(), null);
      }
    });

    var vehicleGroupChangedEvnt = $scope.$on('vehicleGroupChanged', function (event, data) {
      commonTrackService._loopWidgetsInDashboard($scope.dashBoardModel, commonTrackService.getFleetBasedWidgetNameArray(), data.selectedVehicleGroupLabel);
    });


    var widgetDataFromServer = $scope.$on('init-widget-data-from-server', function (event, data) {
      if (data.selectedRow) {

        commonTrackService._loopWidgetsInDashboard($scope.dashBoardModel, [{
          name: 'tachoEventDetailWidget',
          titleTranslationKey: 'dashBoard.fleetManagement.tachoEventDetail.tachoEventDetailTitle'
        }], data.selectedRow.date.replace('/','.'));
      }
    });

    $scope.$on('$destroy', function () {
        rowSelectedEvnt();
        adfDashboardChangedEvnt();
        vehicleGroupChangedEvnt();
        widgetDataFromServer();
      }
    );
  });



// WEBPACK FOOTER //
// ./.tmp/components/dashboard/driverDashboard/driverDashboardController.js